import { Card, Field, Input, Stack, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { useTranslation } from '../../i18n'
import { computeCostMetrics } from '../../utils/costMetrics'

const STORAGE_KEY_PREFIX = 'crowds.cost.'

function CostRow({ label, value }) {
  const display = value !== null && value !== undefined
    ? `$${Number(value).toFixed(2)}`
    : '—'
  return (
    <Text fontSize="sm">
      <Text as="span" color="fg.muted">{label}: </Text>
      <Text as="span" fontWeight="semibold">{display}</Text>
    </Text>
  )
}

export function CostCalculator({ eventId, denominators, showRedemption = true }) {
  const { t } = useTranslation()
  const storageKey = STORAGE_KEY_PREFIX + eventId

  const [cost, setCost] = useState(() => {
    try {
      return localStorage.getItem(storageKey) || ''
    } catch {
      return ''
    }
  })

  const handleCostChange = (e) => {
    const val = e.target.value
    setCost(val)
    try {
      localStorage.setItem(storageKey, val)
    } catch { /* ignore */ }
  }

  const metrics = computeCostMetrics(cost, denominators)

  return (
    <Card.Root bg="var(--mc-bg-surface)" border="1px solid" borderColor="var(--mc-border)">
      <Card.Body>
        <Text fontWeight="semibold" mb={3}>{t('analytics.costCalculatorTitle')}</Text>
        <Stack gap={3}>
          <Field.Root>
            <Field.Label>{t('analytics.costInput')}</Field.Label>
            <Input
              type="number"
              min={0}
              step={0.01}
              value={cost}
              onChange={handleCostChange}
              placeholder="0.00"
              w={{ base: '100%', sm: '180px' }}
            />
            <Text fontSize="xs" color="fg.subtle" mt={1}>{t('analytics.costStorageNote')}</Text>
          </Field.Root>
          <Stack gap={1}>
            <CostRow label={t('analytics.costPerScan')} value={metrics.perScan} />
            <CostRow label={t('analytics.costPerParticipant')} value={metrics.perParticipant} />
            <CostRow label={t('analytics.costPerSubmission')} value={metrics.perSubmission} />
            <CostRow label={t('analytics.costPerUsableClip')} value={metrics.perUsableClip} />
            {showRedemption && (
              <CostRow label={t('analytics.costPerRedemption')} value={metrics.perRedemption} />
            )}
          </Stack>
        </Stack>
      </Card.Body>
    </Card.Root>
  )
}
